import Icon from '../components/Icon.vue'

Icon.register({"circle-thin":{"width":1536,"height":1792,"paths":[{"d":"M768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/circle-thin.js
// module id = 970
// module chunks = 0